import { Injectable } from '@angular/core';
import { FeaturesFactory } from 'types';
import { RequestFeatures } from 'src/webid/4.0/model/features';
import { RequestFeaturesV2 } from 'src/webid/4.0/model/features2';

@Injectable()
export class FeaturesV2FactoryImpl implements FeaturesFactory {
    createFromObject(features: any): RequestFeaturesV2 | RequestFeatures {
        if (features?.applicant?.email == null) {
            return new RequestFeatures();
        }
        
        return new RequestFeaturesV2();
    }
}
